module.exports = __webpack_public_path__ + "static/elsaM_screen03-e3744c4636a6cda3e9cbe4e2e5ba235f.jpg";